import { render, staticRenderFns } from "./GtXkxx.vue?vue&type=template&id=bf14d036&scoped=true"
import script from "./GtXkxx.vue?vue&type=script&lang=js"
export * from "./GtXkxx.vue?vue&type=script&lang=js"
import style0 from "./GtXkxx.vue?vue&type=style&index=0&id=bf14d036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf14d036",
  null
  
)

export default component.exports